<glxy-page [isLoading]="loading$ | async">
  <glxy-page-toolbar>
    <glxy-page-nav>
      <glxy-page-nav-button
        [previousPageTitle]="'CUSTOMIZE_SALES_ORDERS_DECLINE_REASONS.PREVIOUS_PAGE_TITLE' | translate"
        [previousPageUrl]="'/customize-design'"
      ></glxy-page-nav-button>
    </glxy-page-nav>
    <glxy-page-title>
      {{ 'CUSTOMIZE_SALES_ORDERS_DECLINE_REASONS.PAGE_TITLE' | translate }}
    </glxy-page-title>
    <glxy-page-actions>
      <button
        *ngIf="(declineReasons$ | async)?.length > 0"
        mat-flat-button
        color="primary"
        (click)="openActionDialog(action.ADD)"
        [disabled]="loading$ | async"
      >
        {{ 'CUSTOMIZE_SALES_ORDERS_DECLINE_REASONS.ADD_REASON' | translate }}
      </button>
    </glxy-page-actions>
  </glxy-page-toolbar>

  <glxy-page-wrapper [maxWidth]="720" *ngIf="(loading$ | async) === false || (declineReasons$ | async) !== null">
    <ng-container *ngIf="(declineReasons$ | async)?.length > 0; else emptyState">
      <glxy-alert type="tip">
        <strong>
          {{ 'CUSTOMIZE_SALES_ORDERS_DECLINE_REASONS.ALERT_TITLE' | translate }}
        </strong>
        &mdash;
        {{ 'CUSTOMIZE_SALES_ORDERS_DECLINE_REASONS.ALERT_INFO' | translate }}
      </glxy-alert>

      <mat-card>
        <mat-list role="list">
          <ng-container *ngFor="let r of declineReasons$ | async; let last = last">
            <mat-list-item role="listitem">
              {{ r.reason }}
              <div matListItemMeta>
                <button
                  mat-icon-button
                  color="primary"
                  [disabled]="loading$ | async"
                  (click)="openActionDialog(action.EDIT, r)"
                >
                  <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button [disabled]="loading$ | async" (click)="openActionDialog(action.ARCHIVE, r)">
                  <mat-icon>close</mat-icon>
                </button>
              </div>
            </mat-list-item>
            <mat-divider *ngIf="!last"></mat-divider>
          </ng-container>
        </mat-list>
      </mat-card>
    </ng-container>
  </glxy-page-wrapper>
</glxy-page>

<ng-template #emptyState>
  <glxy-empty-state>
    <glxy-empty-state-hero>
      <img [src]="getImageSrc('images/empty-state/material-list-empty-state.png')" />
    </glxy-empty-state-hero>
    <glxy-empty-state-title>
      {{ 'CUSTOMIZE_SALES_ORDERS_DECLINE_REASONS.EMPTY_STATE.TITLE' | translate }}
    </glxy-empty-state-title>
    <p *ngIf="(error$ | async) === false">
      {{ 'CUSTOMIZE_SALES_ORDERS_DECLINE_REASONS.EMPTY_STATE.MESSAGE' | translate }}
    </p>
    <glxy-empty-state-actions>
      <button mat-flat-button color="primary" (click)="openActionDialog(action.ADD)" [disabled]="loading$ | async">
        {{ 'CUSTOMIZE_SALES_ORDERS_DECLINE_REASONS.ADD_REASON' | translate }}
      </button>
    </glxy-empty-state-actions>
  </glxy-empty-state>
</ng-template>
